import { render, staticRenderFns } from "./AsignacionDialog.vue?vue&type=template&id=4ed660be&"
import script from "./AsignacionDialog.vue?vue&type=script&lang=ts&"
export * from "./AsignacionDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports